export const IS_DEV =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const isClientSide = typeof window !== "undefined";

export const listTypeImg = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/gif",
];
export const acceptType = ".png, .jpeg, .jpg, .gif";
const version = "/v1.0";
export const API = {
  SERVER: {
    POWER_BI: {
      WORKSPACE: "/api/powerbi/workspaces",
      REPORT: "/api/powerbi/reports",
      TOKEN: "/api/powerbi/token",
      INTERACTIVE: "/api/powerbi/interactive",
      EXPORT_FILE_IN_GROUP: "/api/powerbi/exportFileGroup",
      GET_FILE_STATUS: "/api/powerbi/exportFileStatus",
      GET_FILE: "/api/powerbi/files",
    },
  },
  ORGANIZATION: {
    DEFAULT: "/v1.0/organization",
    MEMBERS: "/v1.0/organization/members",
    UPDATE_ROLE: "/v1.0/organization/update-role-member",
    GET_BY_USER_ID: "/v1.0/organization/user/:userId",
    OUT: "/v1.0/user/organization/:id/out",
    CHANGE_NAME: "/v1.0/organization/:id/change-name",
    DELETE: "/v1.0/organization/:id/member",
    TRANSFER_OWNER: "/v1.0/organization/:id/transfer-ownership",
    CREATE: "/v1.0/organization/create",
  },
  AUTH: {
    ME: "/v1.0/user/me",
    ME_BY_ID: "/v1.0/user/get-by-id",
    CONFIG: "/v1.0/config",
    LOGIN: "/v1.0/user/login",
    LOGIN_SOCIAL: "/v1.0/user/login/social",
    SEND_VERIFY_EMAIL: "/v1.0/user/send-verify-email",
    REGISTER: "/v1.0/user/register",
    REGISTER2: "/v1.0/user/register2",
    ACTIVE: "/v1.0/user/active",
    SEND_EMAIL_FORGOT_PASSWORD: "/v1.0/user/send-email-forgot-password",
    FORGOT_PASSWORD: "/v1.0/user/forgot-password",
    CHECK_ISVALID_CODE: "/v1.0/user/check-isvalid-code",
    CHECK_EMPTY_PASSWORD: "/v1.0/user/check-empty-password",
    CHECK_EMAIL: "/v1.0/user/check-email",
    CHANGE_LANGUAGE: "/v1.0/user/change-language",
    CHANGE_CURRENCY: "/v1.0/user/change-currency",
    CHECK_INVITATION: "/v1.0/user/check-initation-code",
    UPDATE_AVATAR: "/v1.0/user/update-avatar",
    CHANGE_NAME: "/v1.0/user/change-name",
    CHANGE_PHONE: "/v1.0/user/change-phone",
    CHANGE_COMPANY_NAME: "/v1.0/user/change-company-name",
    CHANGE_PASSWORD: "v1.0/user/change-password",
    ADD_FAVORITE: version + "/user/add-favorite",
    SEND_OTP_AUTH: version + "/user/send-otp-auth",
    OPTIONAL_2FA: version + "/user/optional-2fa",
    ACCEPT_2FA: version + "/user/verify-2fa",
    RESEND_2FA: version + "/user/resend-otp",
    SUBSCRIPTION: version + "/user/subscription",
    CANCEL_SUBSCRIPTION: version + "/user/subscription/:subscriptionId/cancel",
    ACTIVE_TRIAL: version + "/user/subscription/trial-active",
    CHECK_DOMAIN_EMAIL: version + "/user/check-domain-email",
    CHECK_HISTORY_LOG: version + "/user/check-history-log",
    CHECK_EMAIL_BLOCKED: version + "/user/check-email-blocked",
    CHECK_INVITED_CODE: version + "/user/check-invitation-code",
    APPROVE_ORGANIZATION: version + "/user/approve-organization",
    REJECT_ORGANIZATION: version + "/user/reject-organization",
    UPDATE_ORGANIZATION: version + "/user/update-organization",
    CANCEL_SUBSCRIPTION_ORGANIZATION: version + "/user/subscription/:id/revoke",
    TURN_OFF_WARNING: version + "/user/turn-off-warning-organization",
    VERIFY_OTP: version + "/user/verify-otp",
    RESEND_OTP_VERIFY: version + "/user/resend-otp-verify",
  },
  ADMIN: {
    CATEGORY: {
      GET_ALL: version + "/admin/category",
      GET_ONE: version + "/admin/category/:id",
      CHANGE_STATUS: version + "/admin/category/:id/update-status",
    },
    SUBCRIBER: {
      GET_ALL: version + "/admin/subscriber",
      GET_ONE: version + "/admin/subscriber/:id",
    },
    REPORT_DOWNLOAD: {
      GET_ALL: version + "/admin/report-download",
      GET_ONE: version + "/admin/report-download/:id",
      DELETE: version + "/admin/report-download/:id/delete",
      EXPORT_REPORT: version + "/admin/report-download/export-excel",
    },
    ORGANIZATION: {
      GET_ALL: version + "/admin/organization",
      GET_MEMBERS: version + "/admin/organization/:id/members",
      GET_LICENSES: version + "/admin/organization/:id/licenses",
      TRANSFER_OWNERSHIP:
        version +
        "/admin/organization/:organizationId/member/:id/transfer-ownership",
      EVOKE_LICENSE:
        version +
        "/admin/organization/:organizationId/license/:id/evoke-license",
      CREATE_LICENSE: version + "/admin/organization/:id/create",
      DELETE_LICENSE:
        version + "/admin/organization/:organizationId/license/:id/delete",
      DELETE_ORGANIZATION: version + "/admin/organization/:id/delete",
    },
    POWERBI: {
      ACCESS_TOKEN: "https://login.microsoftonline.com/:id/oauth2/v2.0/token",
      WORKSPACE: "/groups",
      INTERACTIVE: "/groups/:workspaceId/reports",
    },
    SUBSCRIPTION: {
      GET_ALL: version + "/admin/subscription",
      GET_ACTIVE: version + "/admin/subscription/active",
      GET_ONE: version + "/admin/subscription/:id",
      CHANGE_STATUS: version + "/admin/subscription/:id/update-status",
      CHANGE_HIDDEN: version + "/admin/subscription/:id/update-hidden",
    },
    SEO: {
      GET_ALL: version + "/admin/seo",
      GET_ONE: version + "/admin/seo/:id",
    },
    USER: {
      GET_ALL: version + "/admin/user",
      GET_ONE: version + "/admin/user/:id",
      GET_ALL_NOT_SUBRIBER: version + "/admin/user/:id/not-subscribed",
      GET_FAVORITE: version + "/admin/user/:id/favorites",
      GET_SUBSCRIPTION: version + "/admin/user/:id/subscription",
      CHANGE_SUBSCRIPTION: version + "/admin/user/:id/subscription/change",
      CANCEL_SUBSCRIPTION:
        version + "/admin/user/:id/subscription/:subscriptionId/cancel",
      GET_SUBSCRIBER: version + "/admin/user/:id/subscribers",
      GET_SUBSCRIBER_ONE: version + "/admin/user/:id/subscriber/:subscriberId",
      RESTORE: version + "/admin/user/:id/restore",
      EXPORT: version + "/admin/user/export-user",
      CHECK_IS_OWNER_ORGANIZATION:
        version + "/admin/user/:id/is-owner-organization",
      CHANGE_STATUS: version + "/admin/user/:id/change-status",
      DELETE_PERMANENT: version + "/admin/user/:id/delete-user-permanently",
    },
    REPORT: {
      GET_ALL: version + "/admin/report",
      GET_ONE: version + "/admin/report/:id",
      CHANGE_STATUS: version + "/admin/report/:id/update-status",
      GET_ALL_RELATED_REPORTS: version + "/admin/report/related",
      GET_ALL_REPORT_ORDERS: version + "/admin/report/orders",
      UPDATE_ORDER: version + "/admin/report/orders/update",
      UPDATE_IS_HOT: version + "/admin/report/:id/update-hot",
      GET_ALL_ANALYZE_REPORTS: version + "/admin/report/analytics",
      EXPORT: version + "/admin/report/export",
    },
    COUNTRY: {
      GET_ALL: version + "/admin/country",
      GET_ONE: version + "/admin/country/:id",
    },
    CATEGORY_REPORT: {
      GET_ALL: version + "/admin/category-report",
      GET_ONE: version + "/admin/category-report/:id",
      UPDATE_STATUS: version + "/admin/category-report/update-status/:id",
    },
    TOPIC: {
      GET_ALL: version + "/admin/topic",
      GET_ONE: version + "/admin/topic/:id",
      RESTORE: version + "/admin/topic/:id/restore",
    },
    CONFIG: {
      GET_ALL: version + "/admin/config",
      GET_ONE: version + "/admin/config/:id",
      EXPORT_AUTO_EMAIL: version + "/admin/config/export-email-auto-active",
      IMPORT_AUTO_EMAIL: version + "/admin/config/import-email-auto-active",
      APPLY_AUTO_EMAIL: version + "/admin/config/apply-email-auto-active",
    },
    VOUCHER: {
      GET_ALL: version + "/admin/voucher",
      GET_ONE: version + "/admin/voucher/:id",
      CHANGE_STATUS: version + "/admin/voucher/:id/update-status",
      EXPORT: version + "/admin/voucher/export",
      COUNT_ALL_STATUS: version + "/admin/voucher/count-all-status",
    },
    VOUCHER_CATEGORY: {
      GET_ALL: version + "/admin/voucher-category",
      GET_ONE: version + "/admin/voucher-category/:id",
    },
    VOUCHER_PARTNER: {
      GET_ALL: version + "/admin/voucher-partner",
      GET_ONE: version + "/admin/voucher-partner/:id",
    },
    FAQ: {
      GET_ALL: version + "/admin/faq",
      GET_ONE: version + "/admin/faq/:id",
      UPDATED_PUBLISHED: version + "/admin/faq/:id/update-published",
    },
    FAQ_CATEGORY: {
      GET_ALL: version + "/admin/faq-category",
      GET_ALL_OPTIONAL: version + "/admin/faq-category/optional",
      GET_ONE: version + "/admin/faq-category/:id",
      UPDATED_ACTIVE: version + "/admin/faq-category/:id/update-active",
    },
    PAYMENT: {
      GET_ALL: version + "/admin/payment",
      GET_ONE: version + "/admin/payment/:id",
      EXPORT: version + "/admin/payment/export",
    },
    REPORT_ATTACHMENT: {
      GET_ALL: version + "/admin/report-attachment",
      GET_ONE: version + "/admin/report-attachment/:id",
    },
    EMAIL_BLOCK: {
      GET_ALL: version + "/admin/email-block",
      GET_ONE: version + "/admin/email-block/:id",
      CREATE_MANY: version + "/admin/email-block/create-many",
    },
    EMAIL_TEMPLATE: {
      GET_ALL: version + "/admin/email-template",
      GET_ONE: version + "/admin/email-template/:id",
      // UPDATE: version + "/admin/email-template/:id/update",
    },
    TRANSLATION: {
      GET_ALL: version + "/admin/translation",
      GET_ONE: version + "/admin/translation/:id",
      EXPORT: version + "/admin/translation/export",
    },
    EMAIL_REMINDER: {
      GET_ALL: version + "/admin/email-reminder",
      GET_ONE: version + "/admin/email-reminder/:id",
      PORT_EMAIL_REMINDER: version + "/admin/email-reminder",
      UPDATE_EMAIL_REMINDER: version + "/admin/email-reminder/:id",
      DELETE_EMAIL_REMINDER: version + "/admin/email-reminder/:id",
    },
    WEBHOOK: {
      DEFAULT: "/v1.0/admin/webhook",
    },
    ROLE: {
      GET_ALL: version + "/admin/role",
      GET_ONE: version + "/admin/role/:id",
      GET_ALL_PERMISSION: version + "/admin/role/get-permissions",
      PERMISSION: {
        ROOT: version + "/admin/role/:id/permission",
      },
    },
    MODULE: {
      ROOT: version + "/admin/module",
    },
  },
  SUBSCRIBER: {
    GET_ALL: version + "/user/subscribers",
    GET_ONE: version + "/user/:subscriberId/subscriber",
    REMOVE_SELECTED: version + "/subscriber/revoke-multiple-subscriber",
    ADD_MEMBER: version + "/subscriber/add-subscriber",
    REVOKE_MEMBER: version + "/subscriber/revoke-subscriber",
    APPLY: version + "/subscriber/apply-subscription",
    ACCEPT: version + "/subscriber/accept-organization-invitation",
    REMOVE_INVITED: version + "/subscriber/remove-invited",
    REMOVE_LIST_INVITED: version + "/subscriber/remove-list-invited",
  },
  POWERBI: {
    GET_TOKEN: "/groups/:workspaceId/reports/:powerBiId/GenerateToken",
    GET_EXPORT_FILE_IN_GROUP: "/groups/:groupId/reports/:reportId/ExportTo",
    GET_FILE: "/groups/:groupId/reports/:reportId/exports/:exportId/file",
    GET_STATUS: "/groups/:groupId/reports/:reportId/exports/:exportId",
    GET_ALL_DASHBOARDS: version + "/powerbi",
    GET_ONE: version + "/powerbi/:token",
    CHANGE_NAME: version + "/powerbi/:id/change-name",
    DELETE: version + "/powerbi/:id/delete",
    DELETE_SELECTED: version + "/powerbi/delete-selected",
    GET_BY_REPORT: version + "/powerbi/report/:reportId",
    GET_POWERBI_TOKEN: version + "/powerbi/get-token",
  },
  SUBSCRIPTION: {
    GET_ALL: version + "/subscription",
    GET_ONE: version + "/subscription/:id",
    GET_ONE_MIN: version + "/subscription/min",
    GET_ALL_BY_USER_ID: version + "/subscription/user/:id",
    GET_BY_IDS: version + "/subscription/find-ids",
    CREATE_NEED_HELP: version + "/subscription/need-help",
    GET_TRIAL: version + "/subscription/trial",
  },
  SEO: {
    GET_ONE: version + "/seo/:id",
    GET_ALL_REPORTS: version + "/seo/reports",
    GET_PRIVACY_POLICY: version + "/seo/privacy-policy/:id",
    GET_URLS: version + "/seo/urls",
  },
  FAQ: {
    GET_ALL: version + "/faq",
    GET_ONE: version + "/faq/:id",
  },
  COUNTRY: {
    GET_ALL: version + "/country",
  },
  VOUCHER: {
    CHECK_EXISTED: version + "/voucher/check-exits",
  },
  REPORT: {
    GET_ALL: version + "/report",
    GET_ALL_FAVORITE: version + "/report/favorites",
    GET_FEATURED: version + "/report/features",
    GET_ONE_BY_ID: version + "/report/by-id/:id",
    GET_ONE_BY_SLUG: version + "/report/by-slug/:slug",
    PORT_DOWNLOAD: version + "/report/download-report",
    FEATURED: version + "/report/features",
    CREATE_SHARE: version + "/report/shared",
    GET_SHARED_DETAILS: version + "/report/shared/:token/detail",
    GET_SHARED_REPORT: version + "/report/shared/:token",
    DELETE_SHARED_REPORT: version + "/report/shared/:token",
    UPDATE_SHARED_REPORT: version + "/report/shared/:token",
    GET_SHARED_BY_REPORT: version + "/report/shared/:reportId/list",
    CHECK_LIMIT_SHARE_REPORT: version + "/report/check-limit-share/:reportId",
    ACCESS_PROTECTED_SHARE: version + "/report/shared/protected",
    MINIMAL_REPORT: version + "/report/minimal-report",
    GET_ALL_BOOKMARKS: version + "/report/bookmarks",
    CHANGE_NAME_BOOKMARK: version + "/report/bookmarks/:bookmarkId/change-name",
    GET_ALL_RELATED_REPORTIDS: version + "/report/related-reportIds",
    GET_DOWNLOAD_REPORT: version + "/report/download-report/:code/:language",
    GET_ALL_COMMING_SOON: version + "/report/coming-soon",
  },
  CATEGORY: {
    GET_ALL: version + "/report-category",
  },
  CATEGORY_WP: {
    GET_ALL: version + "/category",
  },
  TRANSLATION: {
    DEFAULT: "/v1.0/translation/{{lng}}/{{ns}}",
  },
  PAYMENT: {
    CHECKOUT: "/v1.0/payment/checkout",
    CHECKOUT_SUBSCRIPTION: "/v1.0/payment-subscription/checkout",
    CHECKOUT_MULTIPLE_SUBSCRIPTION:
      "/v1.0/payment-multiple-subscription/checkout",
    ONEPAY_CALLBACK: "/v1.0/payment/onepay/callback",
    ONEPAY_CALLBACK_SUBSCRIPTION: "/v1.0/payment-subscription/onepay/callback",
    ONEPAY_CALLBACK_MULTIPLE_SUBSCRIPTION:
      "/v1.0/payment-multiple-subscription/onepay/callback",
    PAYMENT_INFO: "/v1.0/user/payment-info",
    INVOICE: "/v1.0/payment/invoice",
    INVOICE_SUBSCRIPTION: "/v1.0/payment-subscription/invoice",
    DETAIL: "/v1.0/payment/:id",
    SUBSCRIPTION_DETAIL: "/v1.0/payment-subscription/:id",
    GET_BILLING_HISTORY: "/v1.0/payment/billing-histories",
  },
  PURCHASED_REPORTS: {
    GET_ALL: version + "/report/history-payment",
  },
};
export const OPEN_AI_FULL = "OPEN_OPTION_AI_FULL";
export const IS_REFRESHING = "IS_REFRESHING";
export const ACCESS_TOKEN = "ATOKEN";
export const REFRESH_TOKEN = "RTOKEN";
export const LANG = "lang";
export const ROLE = "ROLE";
export const USER = "USER";
export const CURRENT_URL = "X-CURRENT-URL";
export const REFRESH_TOKEN_CACHE = "REFRESH_TOKEN_CACHE";
export const POWERBI_TOKEN = "TOKEN_PI";
export const EMPTY_NUMBER: any[] = [null, undefined, "", NaN];
export const EXPIRED_TIME = "EXPIRED_TIME";
export const NUMBER_REGEX = {
  INTEGER_UNSIGNED: /^\d*$/,
  INTEGER_SIGNED: /^-?\d+$/,
  DECIMAL_UNSIGNED_UNLIMIT: /^\d+(\.\d+)?$/,
  DECIMAL_SIGNED_UNLIMIT: /^-?\d+(\.\d+)?$/,
  DECIMAL_UNSIGNED: (min: number = 1, max: number = 3) =>
    new RegExp(`^\\d+(\\.\\d{${min < 1 ? 1 : min},${max < 1 ? 1 : max}})?$`),
  DECIMAL_SIGNED: (min: number = 1, max: number = 3) =>
    new RegExp(`^-?\\d+(\\.\\d{${min < 1 ? 1 : min},${max < 1 ? 1 : max}})?$`),
};
export type NUMBER_REGEX_TYPE = keyof typeof NUMBER_REGEX;

export type NUMBER_FORMATTER_TYPE = "normal" | "percent";
